import { observer } from 'mobx-react-lite';
import { Button, Card, Container, Header, Icon, Label, Segment } from 'semantic-ui-react';
import format from 'date-fns/format';
import { Permit } from '../../../app/models/permit';
import { useStore } from '../../../app/stores/store';
import PermitDetailedInfoSchedule2 from './PermitDetailedInfoSchedule2';
import PermitDetailedInfoSchedule1 from './PermitDetailedInfoSchedule1';
import PermitDetailedRiderPopupPage from '../form/edit/PermitDetailedRiderPopupPage';
import VehicleCardContent from '../common/VehicleCardContent';
import RiderCardContent from '../common/RiderCardContent';

interface Props {
    permit: Permit
}

export default observer(function PermitDetailedInfo({ permit }: Props) {
    const {permitStore, modalStore} = useStore();
    const { getRouteName } = permitStore;
    const { openModal } = modalStore;
    const buttonSize = 'large';
    
    return (
       <>
            <Segment basic>
                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Route' 
                        color='teal' 
                        floated='left' 
                    />

                    <Header 
                        as='h3'
                        content={`${getRouteName(+permit.routeId)} - Permit Effective Thru: ${format(new Date(permit.permitDetail.effectiveThru), 'MM/dd/yyyy')}`}
                        block
                        className='clear-both'
                    />
                </Segment>

                <Segment>
                    <Header 
                        as='h2' 
                        dividing 
                        content={permit.scheduleTypeInd === "1" ? 'Weekly Sailing Schedule' : 'Alternating Sailing Schedule - Week 1'} 
                        color='teal' 
                        floated='left' 
                    />

                    <PermitDetailedInfoSchedule1 permit={permit} />

                    {permit.scheduleTypeInd === "2" &&
                        <PermitDetailedInfoSchedule2 permit={permit} />
                    }

                    <Segment basic>
                        <Header 
                            content='Customer Schedule Comments:'
                        />
                        {permit.customerScheduleComment ? permit.customerScheduleComment : 'None'}
                    </Segment>
                </Segment>

                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Vehicle Information' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        content='Change'
                        size={buttonSize}
                        disabled={true}
                        className='change-btn'
                    />
                    <Segment basic className='clear-both'>
                        <Card.Group itemsPerRow={3} stackable doubling>
                        {permit && permit.vehicles.map((v) => (
                            <Card 
                                key={`${v.vehicleSeqNbr}`}
                                className={v.vehicleSeqNbr === 1 ? 'border-green' : 'no-border'}
                            >
                                {v.vehicleSeqNbr === 1 ? (
                                    <Label 
                                        size='large'
                                        color='green' 
                                        attached='top'
                                    >
                                    <Icon name='star' />
                                    Primary
                                    </Label>
                                ) : (
                                    <Label 
                                        size='large' 
                                        color='orange' 
                                        attached='top'
                                    >
                                        <Icon name='star outline' className='outline-none' />
                                        Alternate
                                    </Label>
                                )}
                                <VehicleCardContent vehicle={v} permit={permit} />
                            </Card>
                        ))}
                        </Card.Group>
                    </Segment>
                </Segment>
                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Rider Information' 
                        color='teal' 
                        floated='left' 
                    />
                    <Button
                        floated='right'
                        onClick={() => openModal(
                            <PermitDetailedRiderPopupPage />
                        )}
                        content='Change'
                        size={buttonSize}
                        disabled={true}
                        className='change-btn'
                    />
                    <Segment basic className='clear-both'>
                        <Card.Group itemsPerRow={3} stackable doubling>
                            {permit && permit.riders.map((r, i) => (
                                <Card key={`${i}`}>
                                    <Label 
                                        size='large'
                                        attached='top'
                                        className='!bg-green-800 !text-white'
                                    >
                                    <Icon name='user' />
                                    Rider {i + 1}
                                    </Label>
                                    <RiderCardContent rider={r} />
                                </Card>
                            ))}
                        </Card.Group>
                    </Segment>
                </Segment>
                <Segment clearing>
                    <Header 
                        as='h2' 
                        dividing 
                        content='Notes' 
                        color='teal' 
                        floated='left' 
                    />
                    <Container className='clear-both'>
                        <Label basic
                            as='a' 
                            // style={{fontSize: '1em'}}
                            size='large'
                            color='blue' 
                            href='mailto: wsfrideshare@wsdot.wa.gov'
                        >At this time these portions of a permit can only be edited by WSF Staff! Request this type of change</Label>
                    </Container>
                </Segment>
            </Segment>
       </>
    )
})